// extracted by mini-css-extract-plugin
export default {"singlePropertySlider":"SinglePropertySlider_singlePropertySlider__PFXq3"};